const Title = ({ title }: { title: string }) => {
  return <h1 className="title">{title}</h1>;
};

export default Title;
